import React, { useEffect, useState } from 'react'
import FeatherIcon from 'feather-icons-react';
import { Container } from 'react-bootstrap';
import { setGlobalLoading } from 'redux/actions/actionCommon';
import { connect } from 'react-redux';
import { Link, useHistory } from 'react-router-dom';
import Step1 from './Includes/Step1';
import Step2 from './Includes/Step2';
import Step3 from './Includes/Step3';
import { addShipping, getServices } from 'utlis/Apis/Shipping_API';
import { toast } from 'react-toastify'
import { SHIPPING_ADDED_SUCCESSFULLY } from 'utlis/AppMessages/AppMessages';
import { ERROR_WHILE_CREATING_SHIPPING } from 'utlis/AppMessages/AppMessages';
import { ERROR_WHILE__NAME } from 'utlis/AppMessages/AppMessages';
import { UNKNOWN_ERROR_OCCURED } from 'utlis/AppMessages/AppMessages';
import { useFormik } from 'formik';
import { ERROR_WHILE_FETCHING_SHIPPINGS } from 'utlis/AppMessages/AppMessages';
import { getCustomerCountries } from 'utlis/Apis/Customers_API';
import { getError } from 'utlis/AppMessages/AppMessages';
import useStoreUrl from 'utlis/CustomHooks/useStoreUrl';

function AddShipping(props) {
    // props
    const { authState } = props

    // store url
    const [storeUrl] = useStoreUrl()

    // states
    const [loading, setLoading] = useState(true)
    const [goSteps, setGoSteps] = useState(0);
    const [shipping, setShipping] = useState({})
    const [services, setServices] = useState({})
    const [countries, setCountries] = useState({})
    const [disableButton, setDisableButton] = useState(false)

    // consts
    const TOTAL_STEPS = 3
    const history = useHistory()

    const setShippingData = (shippingData) => {
        setShipping({ ...shippingData })
    }

    useEffect(() => {
        setLoading(true)
        const headers = {
            "Authorization": `Bearer ${authState.commonToken}`,
            "Api-Token": authState.apiToken,
            "Access-Token": "",
            // "Store-Id": authState.storeId,
        }
        getServices(headers).then(res => {
            setLoading(false)
            const resData = res.data
            window.scrollTo(0, 0)
            if (resData && resData.success) {
                setServices(resData.data)
            }
            if (resData && resData.error) {
                toast.dismiss();
                toast.error(ERROR_WHILE_FETCHING_SHIPPINGS, {
                    autoClose: 3000
                })
            }
        }).catch(err => {
            console.log(`${ERROR_WHILE__NAME} getShippings `, err.message)

            toast.dismiss();
            toast.error(UNKNOWN_ERROR_OCCURED, {
                autoClose: 2500,
                onClose: () => {
                    setLoading(false)
                }
            })
        })
        getCustomerCountries(headers).then(res => {
            const countriesData = res.data
            if (countriesData.success) {
                setCountries(countriesData.data)
            }
            if (countriesData.error) {
                console.log('Error occured while loading countries groups!', res)
            }
        }).catch(err => {
            console.log(`${ERROR_WHILE__NAME} getCountries `, err.message)
            toast.dismiss();
            toast.error(UNKNOWN_ERROR_OCCURED, {
                autoClose: 2500
            })
        })
    }, [authState])

    const addShipping_ = (values) => {
        setLoading(true)
        setDisableButton(true)

        const finalValues = {
            ...values,
            show_estimated_delivery_date: values.show_estimated_delivery_date ? 1 : 0
        }
        const headers = {
            "Authorization": `Bearer ${authState.commonToken}`,
            "Api-Token": authState.apiToken,
            "Access-Token": "",
            // "Store-Id": authState.storeId,
        }
        addShipping(headers, finalValues).then(res => {
            setDisableButton(false)
            setLoading(false)
            setGlobalLoading(false)
            const shippingData = res.data

            if (shippingData.success) {
                window.scrollTo(0, 0)
                toast.dismiss();
                props.history.push(storeUrl + '/settings/shippings', {
                    shouldReload: true
                })
                toast.success(SHIPPING_ADDED_SUCCESSFULLY, {
                    autoClose: 2000,
                    onClose: () => { }
                })
            }
            if (shippingData.error) {
                setLoading(true)
                console.log(ERROR_WHILE_CREATING_SHIPPING, res)
                toast.dismiss();
                toast.error(getError(shippingData.message, ERROR_WHILE_CREATING_SHIPPING) || ERROR_WHILE_CREATING_SHIPPING, {
                    autoClose: 3000,
                })
                setLoading(false)
                setDisableButton(false)
            }
        }).catch(err => {
            setLoading(false)
            console.log(`${ERROR_WHILE__NAME} addShipping `, err.message)
            toast.dismiss();
            toast.error(err.message || UNKNOWN_ERROR_OCCURED, {
                autoClose: 2500,
                onClose: () => {
                    setGlobalLoading(false)
                }
            })
        })
    }

    // handle go back
    const handleGoBack = (ev) => {
        ev.preventDefault()

        console.log("goSteps ", goSteps);

        if(goSteps === 0) {
            history.push(storeUrl + "/settings/shippings") // moving back
        }

        if(goSteps === 1) {
            setGoSteps(0) // opening step 0
        }

        if(goSteps === 2) {
            setGoSteps(1) // opening step 2
        }
    }

    return (
        <section id="app-saleOrders__create-details" className="st-def-mar-TB">
            <Container fluid className="st-container">
                <div className="app-saleOrders__create-details">
                    <div className="app-header-wrapper mb-4">
                        <div className="back-button-wrapper mb-2">
                            <div className="st-text-primary d-inline-flex align-items-center cursor-pointer st-fs-15" onClick={handleGoBack}>
                                <FeatherIcon
                                    icon="arrow-left"
                                    size="14"
                                    className="icon me-1"
                                />
                                <span>Back</span>
                            </div>
                        </div>
                        <p className="app-heading text-capitalize">New Shipping Method</p>
                    </div>
                    <div className="sale-content-container">
                        <div className="sale-order-loading">

                            {/* progress indicator */}
                            <div className="progress-indicator mb-3">
                                {
                                    (goSteps === 0) ? (
                                        <>
                                            <div className="text st-fw-600 st-fs-17 mb-2">
                                                <span className="st-text-success me-2 st-text-color">
                                                    Step 1 from {TOTAL_STEPS}.
                                                </span>
                                                <span>Select shipping method</span>
                                            </div>

                                            {/* progress bar */}
                                            <div className={`progress-main ${(goSteps === 0) ? "step-1" : ""}`}>
                                                <div className="inner" style={{width: "33.3%"}}></div>
                                            </div>
                                        </>
                                    ) : null
                                }
                                {
                                    (goSteps === 1) ? (
                                        <>
                                            <div className="text st-fw-600 st-fs-17 mb-2">
                                                <span className="st-text-success me-2 st-text-color">
                                                    Step 2 from {TOTAL_STEPS}.
                                                </span>
                                                <span>{!shipping.carrier_name ? `Set up rates` : `Set up rates for ${shipping.carrier_name}`}</span>
                                            </div>

                                            {/* progress bar */}
                                            <div className={`progress-main ${(goSteps === 2) ? "step-2" : ""}`}>
                                                <div className="inner" style={{width: "66.6%"}}></div>
                                            </div>
                                        </>
                                    ) : null
                                }
                                {
                                    (goSteps === 2) ? (
                                        <>
                                            <div className="text st-fw-600 st-fs-17 mb-2">
                                                <span className="st-text-success me-2 st-text-color">
                                                    Step 3 from {TOTAL_STEPS}.
                                                </span>
                                                <span>Finalize</span>
                                            </div>

                                            {/* progress bar */}
                                            <div className={`progress-main ${(goSteps === 3) ? "step-3" : ""}`}>
                                                <div className="inner" style={{width: "100%"}}></div>
                                            </div>
                                        </>
                                    ) : null
                                }
                            </div>
                        </div>

                        {/* hiding the previous section - START */}
                        <div className="sale-order-steps d-none">
                            <div className="sale-order-stepper">
                                <div className="stepper-container">
                                    <div className="stepper-step">
                                        <button className={`${goSteps === 0 ? "active" : "completed"}`}
                                            disabled={loading}
                                            onClick={(e => {
                                                if (goSteps > 0) {
                                                    setGoSteps(0)
                                                }
                                            })}

                                        >
                                            <span className="stepper-label">
                                                {goSteps === 0 ? "1" :
                                                    <FeatherIcon
                                                        icon="check"
                                                        size="18"
                                                        className="icon position-relative"
                                                        style={{ strokeWidth: 4 }}
                                                    />}
                                            </span>
                                        </button>
                                        <div className={`stepper-title ${goSteps === 0 ? "active" : "completed"}`}>
                                            <span className="step-label" style={{ fontFamily: 'Source Sans Pro, sans-serif' }}>
                                                Select shipping method
                                            </span>
                                        </div>
                                    </div>
                                </div>

                                <div className="stepper-container">
                                    <div className="vertical-border active">
                                        <span className={`center-border ${goSteps === 0 ? "active" : "completed"}`}></span>
                                    </div>
                                    <div className="stepper-step">
                                        <button className={`${goSteps > 1 ? "completed" : goSteps !== 0 ? "active" : goSteps === 0 ? "" : ""}`}
                                            disabled={loading}
                                            onClick={(e => {
                                                if (goSteps > 1) {
                                                    setGoSteps(1)
                                                }
                                            })}
                                        >
                                            <span className="stepper-label">
                                                {
                                                    goSteps > 1 ? <FeatherIcon
                                                        icon="check"
                                                        size="18"
                                                        className="icon position-relative"
                                                        style={{ strokeWidth: 4 }}
                                                    /> :
                                                        goSteps !== 0 ? "2" :
                                                            goSteps === 0 ? "2" : ""
                                                }

                                            </span>
                                        </button>
                                        <div className={`stepper-title ${goSteps > 1 ? "completed" : goSteps !== 0 ? "active" : goSteps === 0 ? "" : ""}`}>
                                            <span className="step-label " style={{ fontFamily: 'Source Sans Pro, sans-serif' }}>{!shipping.shipping_name ? "Set up rates" : `Set up rates for ${shipping.shipping_name}`}</span>
                                        </div>
                                    </div>
                                </div>

                                <div className="stepper-container">
                                    <div className="vertical-border">
                                        <span className={`center-border ${goSteps === 2 ? "completed" : ""}`}></span></div>
                                    <div className="stepper-step">
                                        <button className={`${goSteps > 2 ? "active" : ""}`}
                                            disabled={loading}
                                            onClick={(e => {
                                                if (goSteps > 1) {
                                                    setGoSteps(1)
                                                }
                                            })}
                                        >
                                            <span className="">
                                                {
                                                    goSteps > 2 ? <FeatherIcon
                                                        icon="check"
                                                        size="18"
                                                        className="icon position-relative"
                                                        style={{ strokeWidth: 4 }}
                                                    /> :
                                                        "3"
                                                }
                                            </span>

                                        </button>
                                        <div className={`stepper-title ${goSteps > 2 ? "completed" : goSteps !== 0 && goSteps !== 1 ? "active" : goSteps === 0 && goSteps === 1 ? "" : ""}`}>
                                            <span className="step-label " style={{ fontFamily: 'Source Sans Pro, sans-serif' }}>
                                                Finalize
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* hiding the previous section - FINISH */}

                        {goSteps === 0 && (
                            <Step1
                                goSteps={goSteps}
                                setGoSteps={setGoSteps}
                                loading={loading}
                                services={services}
                                shipping={shipping}
                                setShipping={setShippingData}
                            />
                        )}
                        {goSteps === 1 && (
                            <Step2
                                goSteps={goSteps}
                                setGoSteps={setGoSteps}
                                shipping={shipping}
                                services={services}
                                setShipping={setShippingData}
                            />
                        )}
                        {goSteps === 2 && (
                            <Step3
                                goSteps={goSteps}
                                services={services}
                                setGoSteps={setGoSteps}
                                shipping={shipping}
                                setShipping={setShippingData}
                                addShipping_={addShipping_}
                                loading={loading}
                                countries={countries}
                                disableButton={disableButton}
                            />
                        )}
                    </div>
                </div>
            </Container >
        </section >
    )
}


const getDataFromStore = state => {
    return {
        authState: state.auth,
        sideBarVisibility: state.common.sideBarVisibility
    };
}

const dispatchActionsToProps = dispatch => {
    return {
        setGlobalLoading: bool => dispatch(setGlobalLoading(bool)),
    }
}

export default connect(getDataFromStore, dispatchActionsToProps)(AddShipping)